import { IApi } from '../../../api'
import { createRequestTypes } from '../../../helpers/helpers'
import { createAction } from '../../types'

export const prefix = 'myTasks/recurrenceRules'

export const GET_RECURRENCE_RULE = createRequestTypes(prefix, 'GET_RECURRENCE_RULE')
export const [
  GET_RECURRENCE_RULE_REQUEST,
  GET_RECURRENCE_RULE_SUCCESS,
  GET_RECURRENCE_RULE_FAILURE,
] = GET_RECURRENCE_RULE

export const getRecurrenceRule = createAction((id: string, params?: object) => ({
  type: GET_RECURRENCE_RULE,
  promise: (api: IApi) => api.myTasks.getRecurrenceRule(id, params),
}))

export const CREATE_RECURRENCE_RULE = createRequestTypes(prefix, 'CREATE_RECURRENCE_RULE')
export const [
  CREATE_RECURRENCE_RULE_REQUEST,
  CREATE_RECURRENCE_RULE_SUCCESS,
  CREATE_RECURRENCE_RULE_FAILURE,
] = CREATE_RECURRENCE_RULE

export const createRecurrenceRule = createAction((data: object) => ({
  type: CREATE_RECURRENCE_RULE,
  promise: (api: IApi) => api.myTasks.createRecurrenceRule(data),
}))

export const UPDATE_RECURRENCE_RULE = createRequestTypes(prefix, 'UPDATE_RECURRENCE_RULE')
export const [
  UPDATE_RECURRENCE_RULE_REQUEST,
  UPDATE_RECURRENCE_RULE_SUCCESS,
  UPDATE_RECURRENCE_RULE_FAILURE,
] = UPDATE_RECURRENCE_RULE

export const updateRecurrenceRule = createAction((id: string, data: object) => ({
  type: UPDATE_RECURRENCE_RULE,
  promise: (api: IApi) => api.myTasks.updateRecurrenceRule(id, data),
}))

export const DELETE_RECURRENCE_RULE = createRequestTypes(prefix, 'DELETE_RECURRENCE_RULE')
export const [
  DELETE_RECURRENCE_RULE_REQUEST,
  DELETE_RECURRENCE_RULE_SUCCESS,
  DELETE_RECURRENCE_RULE_FAILURE,
] = DELETE_RECURRENCE_RULE

export const deleteRecurrenceRule = createAction((id: string) => ({
  type: DELETE_RECURRENCE_RULE,
  promise: (api: IApi) => api.myTasks.deleteRecurrenceRule(id),
}))

export const CLEAR_SELECTED_RECURRENCE_RULE = `${prefix}/CLEAR_SELECTED_RECURRENCE_RULE`

export const clearSelectedRecurrenceRule = () => ({ type: CLEAR_SELECTED_RECURRENCE_RULE })
